export const AUTH_STATUS = {
    PENDING: "pending",
    AUTHENTICATED: "authenticated",
    UNAUTHENTICATED: "unauthenticated",
} as const;
